<script setup lang="ts">
import type { DialogController } from "@/vf"

defineProps<{
    controller: DialogController<boolean, { title: string; message: string }>
}>()
</script>

<template>
    <div>
        <div class="dialog-header">
            <h2>Die Bearbeitung kann sich verzögern</h2>
        </div>
        <div class="dialog-body">
            Aktuell bearbeiten wir bereits sehr viele Bestellungen unserer Kunden. Die Bearbeitung kann sich dadurch um
            ein bis zwei Werktage verzögern.
        </div>
        <div class="dialog-footer">
            <button type="button" class="btn btn-primary" @click="controller.ok(false)">Bestellung abbrechen</button>
            <button type="button" class="btn btn-primary" @click="controller.ok(true)">Trotzdem bestellen</button>
        </div>
    </div>
</template>
